module.exports = __webpack_public_path__ + "media/images/image2-0ef99c538a708a0b6fc4807e8142daed.png";